import { cn } from '../lib/cn.js';

type Angle = 'front' | 'left' | 'right' | 'top' | 'crown' | 'back' | 'hairline';

/**
 * Molde de enquadramento por ângulo (traço tracejado). Usado por cima da câmera no portal
 * e como marcador de "falta esta foto" na tela da equipe. viewBox 300x400.
 */
const PATHS: Record<Angle, string[]> = {
  front: ['M150 60c-55 0-92 42-92 104 0 40 12 76 32 102 16 21 36 38 60 38s44-17 60-38c20-26 32-62 32-102 0-62-37-104-92-104z',
    'M58 170c-12 0-18 10-16 24 2 16 10 26 20 26', 'M242 170c12 0 18 10 16 24-2 16-10 26-20 26', 'M112 304c-2 20-4 34-10 46', 'M188 304c2 20 4 34 10 46'],
  hairline: ['M150 70c-60 0-100 40-100 100 0 46 16 88 44 116 16 16 36 26 56 26s40-10 56-26c28-28 44-70 44-116 0-60-40-100-100-100z',
    'M82 150c20-26 44-34 68-30 24-4 48 4 68 30', 'M100 214h100'],
  left: ['M176 62c-58 0-100 40-100 102 0 30 8 54 20 72l-18 30c-4 8 2 14 10 14h14c4 22 16 34 36 34h20c10 0 16 8 16 18v30',
    'M176 62c52 0 84 40 84 96 0 44-20 74-50 90l-4 60', 'M190 160c-10 0-16 10-14 22 2 12 10 18 18 18'],
  right: ['M124 62c58 0 100 40 100 102 0 30-8 54-20 72l18 30c4 8-2 14-10 14h-14c-4 22-16 34-36 34h-20c-10 0-16 8-16 18v30',
    'M124 62c-52 0-84 40-84 96 0 44 20 74 50 90l4 60', 'M110 160c10 0 16 10 14 22-2 12-10 18-18 18'],
  top: ['M150 70c-70 0-110 56-110 130s40 130 110 130 110-56 110-130S220 70 150 70z', 'M96 112c26-18 82-18 108 0', 'M150 70v40'],
  crown: ['M150 70c-70 0-110 56-110 130s40 130 110 130 110-56 110-130S220 70 150 70z',
    'M150 186c10 0 16 8 14 16-2 10-14 14-24 8-12-8-10-26 4-32 18-8 38 4 40 24 2 22-20 38-42 34'],
  back: ['M150 58c-58 0-96 44-96 104 0 44 14 80 38 104 12 12 20 30 22 50h72c2-20 10-38 22-50 24-24 38-60 38-104 0-60-38-104-96-104z',
    'M70 196c26 22 54 30 80 30s54-8 80-30', 'M58 170c-12 0-18 10-16 24 2 16 10 26 20 26', 'M242 170c12 0 18 10 16 24-2 16-10 26-20 26'],
};

export function AngleGuide({ angle, className, strokeClassName }: { angle: Angle; className?: string; strokeClassName?: string }) {
  return (
    <svg viewBox="0 0 300 400" aria-hidden className={cn('pointer-events-none', className)} fill="none">
      {PATHS[angle].map((d, i) => (
        <path key={i} d={d} className={cn('stroke-current', strokeClassName)} strokeWidth={3} strokeDasharray="10 8" strokeLinecap="round" strokeLinejoin="round" />
      ))}
    </svg>
  );
}
